import GridContainer from "@/components/common/GridContainer"
import HeaderDescription from "@/components/common/Header&Description"
import React from "react"
import styled from "styled-components"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Wrapper = styled(GridContainer)`
	margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-bottom: ${getCssSizeValue(40)};
	}
`

export default function HeaderDescriptionBlock({ headerDescription, borderColor, ...props }) {
	const indent = headerDescription?.columnStart || 1

	return (
		headerDescription && (
			<Wrapper className={`indent-desktop-${indent}`} {...props}>
				<HeaderDescription
					data={headerDescription}
					indent
					className="col-mobile-8 col-tablet-5 col-desktop-8 border-top"
					borderColor={borderColor}
				/>
			</Wrapper>
		)
	)
}
